'use strict';
import ArTheme from '../argon-ui/Theme';
var React = require('react-native');

var {
  StyleSheet,
} = React;

export default StyleSheet.create({

  container: {
    flex: 1,
    // justifyContent: "center",
    backgroundColor: '#F5FCFF',
    // fontFamily : 'IRANSans',
  },
  navToggle: {
    color: '#c8c0ea',
    paddingRight: 20,
    paddingLeft: 20,
    fontSize: 240
  },
  NavItem: {
    writingDirection: "rtl",
    textAlign: "right",
    backgroundColor:"blue",

  },
  tester: {
    backgroundColor: 'red',

    color: 'orange',
  },
  topHeader: {
    // backgroundColor: ArTheme.COLORS.TL_PURPLE
  },
  dropdownWrapper: { marginTop: 16 },
  dropdownButton: {
    width: "100%",
    backgroundColor: "#FFF",
    marginTop: 5,
    marginBottom: 2,
    borderColor: ArTheme.COLORS.BORDER,
    borderWidth: 1,
    shadowColor: ArTheme.COLORS.BORDER,
    shadowRadius: 2,
    shadowOpacity: 0.05,
  },
  dropdownButtonText: { color: "#000" },
  dropdownMenu: { width: "80%" },
  dropdownMenuText: { paddingVertical: 22 },
  dropdownItem: { justifyContent: 'flex-start', },
  dropdownActiveLabel: { fontWeight: "bold", color: ArTheme.COLORS.MUTED },

  gridList_TouchableFiltersContainer: {
    flexDirection: "row",
    paddingStart: 10,
    paddingEnd: 10,
    paddingTop: 5,
    height: 37,
    backgroundColor: ArTheme.COLORS.BORDER_COLOR,
    borderBottomWidth: 1,
    borderColor: ArTheme.COLORS.BORDER,
  },
  gridList_TouchableFilterItem: {
    borderWidth: 1,
    borderRadius: 15,
    paddingVertical: 2,
    paddingHorizontal: 15,
    margin: 5,
    marginTop: 1,
    borderColor: ArTheme.COLORS.SUCCESS,
    backgroundColor: ArTheme.COLORS.SUCCESS + "40", // add 40/255 opacity
  },
  gridList_MainFiltersContainer: {
    paddingStart: 10,
    paddingEnd: 10,
    paddingTop: 0,
    flexDirection: "row",
    zIndex: 99,
    backgroundColor: ArTheme.COLORS.BORDER_COLOR,
    borderBottomWidth: 1,
    borderColor: ArTheme.COLORS.MUTED,
  },
});